import apiClient from "./api";
import { generarUUID } from "../utils/idempotencyUtils";
const CAJA_API_BASE_URL = "/caja";
class CajaService {
  getCaja() {
    return apiClient.get(CAJA_API_BASE_URL);
  }

  getCortes() {
    return apiClient.get(`${CAJA_API_BASE_URL}/cortes`);
  }
  getCajaActual(sucursalId) {
    return apiClient.get(`${CAJA_API_BASE_URL}/actual/${sucursalId}`);
  }

  crearCorte(corte) {
    return apiClient.post(`${CAJA_API_BASE_URL}/corte`, corte);
  }

  updateCorte(corte) {
    return apiClient.put(`${CAJA_API_BASE_URL}/corte`, corte);
  }

  async getCajaPorSolicitud(solicitudId) {
    try {
      const response = await apiClient.get(
        `${CAJA_API_BASE_URL}/solicitud/${solicitudId}`,
      );
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async getCajaPorCorte(idSucursal, idCorte) {
    try {
      const response = await apiClient.get(
        `${CAJA_API_BASE_URL}/corte/${idSucursal}/${idCorte}`,
      );
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async getCorteGeneral(idSucursal, idCorte) {
    try {
      const response = await apiClient.get(
        `${CAJA_API_BASE_URL}/corte/general/${idSucursal}/${idCorte}`,
      );
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

   async getCorteGeneralActual(idSucursal) {
    try {
      const response = await apiClient.get(
        `${CAJA_API_BASE_URL}/corte/general/actual/${idSucursal}`,
      );
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  pagarSolicitud(pago) {
    const pagoFinal = typeof pago === "object" ? { idempKey: generarUUID(), ...pago } : pago;
    return apiClient.put(`${CAJA_API_BASE_URL}/pagar`, pagoFinal);
  }

  async buscarCortes(busqueda) {
        try {
            const response = await apiClient.post(
                `${CAJA_API_BASE_URL}/cortes/buscar`,
                { busqueda },
            );
            return response.data;
        } catch (error) {
            console.error(error);
        }
    }
}
export default new CajaService();
